import Vue from 'vue';
import { config } from '../config';
import { msalInstance } from '../config/authConfig';
import MSALVuePlugin from '../plugins/msalPlugin';
import { authenticationService } from '../shared/services/AuthenticationService';

function msalBuilder() {
    // Initialize MSAL
    Vue.use(MSALVuePlugin, msalInstance);

    // Initialize the authentication service with the new configuration
    authenticationService.initialize(config.BEEHIVE_AZUREAD_AUDIENCE, config.API_BASE_URL);

    // Handle redirect promise on app startup and return it so main.ts can wait
    return msalInstance.handleRedirectPromise().then((response: any) => {
        // Clear any interaction flags since redirect is complete
        (authenticationService as any).clearInteractionFlag();

        if (response) {
            // User has been redirected back from login
            msalInstance.setActiveAccount(response.account);
        } else {
            // Check if there are any cached accounts
            const currentAccounts = msalInstance.getAllAccounts();
            if (currentAccounts.length > 0) {
                // Set the first account as active
                msalInstance.setActiveAccount(currentAccounts[0]);
            }
        }
    }).catch((error: any) => {
        // Clear any interaction flags even on error
        (authenticationService as any).clearInteractionFlag();
    });
}

// Handle access denied scenarios
authenticationService.handleAccessDenied();

export default msalBuilder;
